import axios from 'axios';

export interface LatestAxiosRequestToken {
    signal: AbortSignal;
    isCurrent(): boolean;
    release(): void;
}

export interface LatestAxiosRequest {
    begin(): LatestAxiosRequestToken;
    invalidate(): void;
    isCancellation(error: unknown): boolean;
}

export function useLatestAxiosRequest(): LatestAxiosRequest {
    let generation = 0;
    let activeController: AbortController | null = null;

    const begin = (): LatestAxiosRequestToken => {
        activeController?.abort();

        const controller = new AbortController();
        const requestGeneration = ++generation;
        activeController = controller;

        return {
            signal: controller.signal,
            isCurrent: () => generation === requestGeneration && activeController === controller,
            release: () => {
                if (activeController === controller) {
                    activeController = null;
                }
            },
        };
    };

    const invalidate = (): void => {
        generation += 1;
        activeController?.abort();
        activeController = null;
    };

    return {
        begin,
        invalidate,
        isCancellation: (error: unknown): boolean => axios.isCancel(error),
    };
}
